import { useEkardoLazyQuery } from '@netfront/ekardo-content-library';

import { LIST_TEXT_TOOLTIPS } from './useListTextTooltips.graphql';
import {
  IGetListTextTooltipsQueryGraphQLResponse,
  IHandleGetListTextTooltipsParams,
  IUseGetListTextTooltips,
  IUseGetListTextTooltipsOptions,
} from './useListTextTooltips.interfaces';

const useListTextTooltips = (options?: IUseGetListTextTooltipsOptions): IUseGetListTextTooltips => {
  const { fetchPolicy, onCompleted, onError, product, query, tokens } = options ?? ({} as IUseGetListTextTooltipsOptions);

  const [executeListTextTooltips, { loading: isLoading }] = useEkardoLazyQuery<IGetListTextTooltipsQueryGraphQLResponse>({
    options: {
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }
        
        const { textTooltip: { list: { edges } } } = data;

        onCompleted({
         textTooltip: edges
        });
      },
      onError,
    },
    product,
    query: query ?? LIST_TEXT_TOOLTIPS,
    tokens,
  });

  const handleListTextTooltips = async ({ projectId }: IHandleGetListTextTooltipsParams) => {
    await executeListTextTooltips({
      variables: {
        projectId,
      },
    });
  };

  return {
    handleListTextTooltips,
    isLoading,
  };
};

export { useListTextTooltips };
